import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NameBadgeComponent } from './name-badge.component';

@NgModule({
  declarations: [NameBadgeComponent],
  imports: [CommonModule],
  exports: [NameBadgeComponent]
})
export class NameBadgeModule {}
